// app/client-layout-wrapper.jsx
"use client";

import { useEffect, useState } from "react";
import ClientLayout from "./client-layout";
import { useSelector, useDispatch } from "react-redux"
import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";
import { setUserData, setUser_ai_limit, setIsFreeLimit, setGlobalLoading } from "@/store/mainSlice";

export default function Layout({ children }) {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch()
  const router = useRouter();
  const { fetchUserData, globalLoading } = useSelector((state) => state.main)
  const pathname = usePathname(); // Current path


  const fetchUserDetail = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const HEADER_URL = `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/users/getUser`;
      const res = await fetch(`${HEADER_URL}/${userId}`, {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
          "Pragma": "no-cache",
          "Expires": "0",
        },
      });
      // if (!res.ok) throw new Error("Failed to fetch user details");
      if (!res.ok) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        router.replace("/login");
        return;
      }

      const data = await res.json();
      let isFree = ["true", true].some(val => data.data.is_free_limit.includes(val));
      dispatch(setUserData(data.data))
      dispatch(setUser_ai_limit(data.data.ai_limit))
      dispatch(setIsFreeLimit(isFree))
    } catch (err) {
      console.error("Error fetching user details:", err);
    }
  };



  useEffect(() => {
    // console.log("Unregistering service workers-1");
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (let registration of registrations) {
          registration.unregister();
        }
      });
    }
  }, []);


  useEffect(() => {
    dispatch(setGlobalLoading(false))
  }, [pathname]); // dependency array me pathname

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");
    if (!token || !userId) {
      router.replace("/login"); // redirect if not logged in
      return;
    } else {
      fetchUserDetail()
      setLoading(false); // token exists, show page
    }
  }, [router, fetchUserData]);
  // [router, fetchUserData]


  // if (loading) {
  //   return (
  //     <div className="flex h-screen items-center justify-center">
  //       <p>Loading...Test</p>
  //     </div>
  //   );
  // }


  // if (globalLoading) {
  //   return <div className="flex h-screen items-center justify-center">
  //     <p>Loading...</p>
  //   </div>
  // }

  return (
    <ClientLayout isCollapsed={true}>
      {children}
    </ClientLayout>
  );
}